const ContactStyles = () => {
  return (
    <style jsx>{`
      .contact-page {
        font-family:
          -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
      }

      /* Hero Section */
      .hero-section {
        background: linear-gradient(135deg, #0a2458 0%, #1a3b8a 100%);
        min-height: 85vh;
        display: flex;
        align-items: center;
        position: relative;
        overflow: hidden;
      }

      .hero-section::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background:
          radial-gradient(
            circle at 20% 80%,
            rgba(255, 215, 0, 0.15) 0%,
            transparent 50%
          ),
          radial-gradient(
            circle at 80% 20%,
            rgba(255, 255, 255, 0.1) 0%,
            transparent 50%
          );
      }

      .hero-content {
        position: relative;
        z-index: 1;
        text-align: center;
        padding: 60px 20px;
      }

      .hero-badge {
        display: inline-flex;
        align-items: center;
        gap: 8px;
        background: rgba(255, 255, 255, 0.1);
        backdrop-filter: blur(10px);
        padding: 8px 16px;
        border-radius: 50px;
        margin-bottom: 24px;
        border: 1px solid rgba(255, 255, 255, 0.2);
      }

      .badge-icon {
        font-size: 20px;
      }

      .badge-text {
        font-size: 14px;
        font-weight: 600;
        letter-spacing: 1px;
        color: white;
      }

      .hero-title {
        font-size: clamp(2.5rem, 5vw, 3.5rem);
        font-weight: 700;
        line-height: 1.1;
        margin-bottom: 20px;
        color: white;
      }

      .hero-highlight {
        background: linear-gradient(90deg, #ffd700 0%, #ffec8b 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
      }

      .hero-subtitle {
        font-size: 1.25rem;
        line-height: 1.6;
        color: rgba(255, 255, 255, 0.9);
        max-width: 600px;
        margin: 0 auto 40px;
      }

      /* Contact Methods */
      .contact-methods {
        padding: 80px 0;
        background: linear-gradient(180deg, #ffffff 0%, #f8faff 100%);
      }

      .method-card {
        background: white;
        border-radius: 20px;
        padding: 32px;
        text-align: center;
        box-shadow: 0 10px 30px rgba(10, 36, 88, 0.08);
        transition: all 0.3s ease;
        height: 100%;
        border: 1px solid rgba(10, 36, 88, 0.1);
      }

      .method-card:hover {
        transform: translateY(-5px);
        box-shadow: 0 20px 40px rgba(10, 36, 88, 0.15);
      }

      .method-icon {
        font-size: 48px;
        margin-bottom: 20px;
        display: block;
      }

      .method-title {
        font-size: 1.5rem;
        color: #0a2458;
        margin-bottom: 12px;
        font-weight: 600;
      }

      .method-description {
        color: #0a2458;
        font-size: 1rem;
        margin-bottom: 16px;
        line-height: 1.5;
      }

      .method-link {
        color: #0a2458;
        font-weight: 600;
        text-decoration: none;
        font-size: 1.125rem;
        display: inline-block;
        transition: all 0.3s ease;
      }

      .method-link:hover {
        color: #1a3b8a;
        transform: translateX(5px);
      }

      /* Main Content */
      .main-content {
        padding: 80px 0;
        background: white;
      }

      /* Form Section */
      .form-section {
        background: white;
        border-radius: 24px;
        padding: 40px;
        box-shadow: 0 20px 60px rgba(10, 36, 88, 0.1);
      }

      .section-title {
        font-size: 2.5rem;
        color: #0a2458;
        margin-bottom: 16px;
        font-weight: 700;
      }

      .section-subtitle {
        color: #0a2458;
        font-size: 1.125rem;
        margin-bottom: 32px;
        line-height: 1.6;
      }

      /* Form Styles */
      .form-group {
        margin-bottom: 24px;
      }

      .form-label {
        display: block;
        color: #0a2458;
        font-weight: 600;
        margin-bottom: 8px;
        font-size: 0.95rem;
      }

      .form-control {
        width: 100%;
        padding: 14px 16px;
        border: 2px solid #e2e8f0;
        border-radius: 12px;
        font-size: 1rem;
        transition: all 0.3s ease;
        background: #f8fafc;
      }

      .form-control:focus {
        outline: none;
        border-color: #0a2458;
        background: white;
        box-shadow: 0 0 0 3px rgba(10, 36, 88, 0.1);
      }

      .form-control.is-invalid {
        border-color: #dc3545;
      }

      .invalid-feedback {
        color: #dc3545;
        font-size: 0.875rem;
        margin-top: 4px;
      }

      .form-text {
        color: #0a2458;
        font-size: 0.875rem;
        margin-top: 4px;
      }

      /* Submit Button */
      .submit-btn {
        background: linear-gradient(135deg, #0a2458 0%, #1a3b8a 100%);
        color: white;
        border: none;
        padding: 16px 32px;
        font-size: 1.125rem;
        font-weight: 600;
        border-radius: 12px;
        cursor: pointer;
        transition: all 0.3s ease;
        display: inline-flex;
        align-items: center;
        gap: 8px;
      }

      .submit-btn:hover:not(:disabled) {
        transform: translateY(-2px);
        box-shadow: 0 10px 25px rgba(10, 36, 88, 0.3);
      }

      .submit-btn:disabled {
        opacity: 0.7;
        cursor: not-allowed;
      }

      /* Success Message */
      .success-message {
        background: linear-gradient(135deg, #10b981 0%, #34d399 100%);
        color: white;
        padding: 20px;
        border-radius: 12px;
        margin-bottom: 24px;
        display: flex;
        align-items: center;
        gap: 12px;
        animation: slideIn 0.3s ease;
      }

      @keyframes slideIn {
        from {
          opacity: 0;
          transform: translateY(-10px);
        }
        to {
          opacity: 1;
          transform: translateY(0);
        }
      }

      /* Sidebar Styles */
      .sidebar-section {
        background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
        border-radius: 20px;
        padding: 32px;
        margin-bottom: 24px;
        border: 1px solid #e2e8f0;
      }

      .sidebar-title {
        font-size: 1.5rem;
        color: #0a2458;
        margin-bottom: 20px;
        font-weight: 600;
      }

      .process-step {
        display: flex;
        gap: 16px;
        margin-bottom: 24px;
      }

      .step-number {
        width: 36px;
        height: 36px;
        background: linear-gradient(135deg, #0a2458 0%, #1a3b8a 100%);
        color: white;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 600;
        font-size: 0.875rem;
        flex-shrink: 0;
      }

      .step-content h4 {
        color: #0a2458;
        margin-bottom: 4px;
        font-size: 1rem;
      }

      .step-content p {
        color: #0a2458;
        font-size: 0.875rem;
        margin: 0;
        line-height: 1.5;
      }

      .resources-list {
        list-style: none;
        padding: 0;
        margin: 0;
      }

      .resources-list li {
        margin-bottom: 12px;
      }

      .resources-list a {
        color: #0a2458;
        text-decoration: none;
        font-weight: 500;
        display: flex;
        align-items: center;
        gap: 8px;
        transition: all 0.3s ease;
      }

      .resources-list a:hover {
        color: #1a3b8a;
        transform: translateX(5px);
      }

      /* Map Section */
      .map-section {
        padding: 0;
        position: relative;
        height: 400px;
        overflow: hidden;
      }

      .map-container {
        width: 100%;
        height: 100%;
        border: none;
        filter: grayscale(0.2);
      }

      /* FAQ Section */
      .faq-section {
        padding: 80px 0;
        background: linear-gradient(180deg, #ffffff 0%, #f8faff 100%);
      }

      .faq-title {
        font-size: 2.5rem;
        color: #0a2458;
        text-align: center;
        margin-bottom: 40px;
        font-weight: 700;
      }

      .faq-item {
        background: white;
        border-radius: 16px;
        padding: 24px;
        margin-bottom: 16px;
        box-shadow: 0 4px 6px rgba(10, 36, 88, 0.05);
        border: 1px solid rgba(10, 36, 88, 0.1);
        transition: all 0.3s ease;
        cursor: pointer;
      }

      .faq-item:hover {
        transform: translateY(-2px);
        box-shadow: 0 10px 25px rgba(10, 36, 88, 0.1);
        border-color: #0a2458;
      }

      .faq-question {
        color: #0a2458;
        font-size: 1.125rem;
        font-weight: 600;
        margin-bottom: 8px;
      }

      .faq-answer {
        color: #0a2458;
        font-size: 1rem;
        line-height: 1.6;
        margin: 0;
      }

      /* Social Links */
      .social-section {
        padding: 60px 0;
        background: white;
      }

      .social-title {
        font-size: 2.5rem;
        color: #0a2458;
        text-align: center;
        margin-bottom: 40px;
        font-weight: 700;
      }

      .social-card {
        background: white;
        border-radius: 20px;
        padding: 32px;
        text-align: center;
        box-shadow: 0 10px 30px rgba(10, 36, 88, 0.08);
        transition: all 0.3s ease;
        height: 100%;
        border: 1px solid rgba(10, 36, 88, 0.1);
      }

      .social-card:hover {
        transform: translateY(-5px);
        box-shadow: 0 20px 40px rgba(10, 36, 88, 0.15);
      }

      .social-icon {
        font-size: 48px;
        margin-bottom: 16px;
        display: block;
      }

      .social-name {
        font-size: 1.25rem;
        color: #0a2458;
        margin-bottom: 8px;
        font-weight: 600;
      }

      .social-description {
        color: #0a2458;
        font-size: 0.875rem;
        margin-bottom: 20px;
      }

      .social-btn {
        background: transparent;
        color: #0a2458;
        border: 2px solid #0a2458;
        padding: 10px 24px;
        border-radius: 8px;
        font-weight: 600;
        text-decoration: none;
        display: inline-block;
        transition: all 0.3s ease;
      }

      .social-btn:hover {
        background: #0a2458;
        color: white;
      }

      /* Testimonial */
      .testimonial-section {
        padding: 80px 0;
        background: linear-gradient(135deg, #0a2458 0%, #1a3b8a 100%);
        position: relative;
        overflow: hidden;
      }

      .testimonial-section::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background:
          radial-gradient(
            circle at 20% 80%,
            rgba(255, 215, 0, 0.1) 0%,
            transparent 50%
          ),
          radial-gradient(
            circle at 80% 20%,
            rgba(255, 255, 255, 0.05) 0%,
            transparent 50%
          );
      }

      .testimonial-content {
        position: relative;
        z-index: 1;
        text-align: center;
        max-width: 800px;
        margin: 0 auto;
      }

      .testimonial-rating {
        color: #ffd700;
        font-size: 32px;
        margin-bottom: 24px;
      }

      .testimonial-quote {
        font-size: 1.5rem;
        color: white;
        font-style: italic;
        line-height: 1.6;
        margin-bottom: 24px;
      }

      .testimonial-author {
        color: rgba(255, 255, 255, 0.9);
        font-size: 1.125rem;
        font-weight: 600;
      }

      /* Responsive Design */
      @media (max-width: 768px) {
        .hero-section {
          min-height: auto;
          padding: 60px 0;
        }

        .form-section {
          padding: 24px;
        }

        .section-title {
          font-size: 2rem;
        }

        .social-card,
        .method-card {
          padding: 24px;
        }

        .faq-title,
        .social-title {
          font-size: 2rem;
        }

        .testimonial-quote {
          font-size: 1.25rem;
        }
      }

      @media (max-width: 480px) {
        .hero-title {
          font-size: 2rem;
        }

        .section-title {
          font-size: 1.75rem;
        }

        .form-control {
          padding: 12px 14px;
        }
      }
    `}</style>
  );
};
export default ContactStyles;
